define(['edge/platform/base/BaseCtrl', 'text!edge/platform/widgets/carousel/config/demoslides.json'], (BaseCtrl, slideContent)=> {
    const fn = ($scope, landingPageContent)=> {
        const ctrl = Object.create(BaseCtrl);


        ctrl.init = ()=> {
            $scope.content = landingPageContent;
            $scope.slideContent = JSON.parse(slideContent);
        };

        return ctrl.create($scope);
    };

    fn.$inject = ['$scope', 'landingPageContent'];

    return fn;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/demolandingpage/controllers/LandingPageCtrl.js